export default __webpack_public_path__ + "static/media/fullscreen-open.44155d1e.svg";